import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';

import {
    LOAD_REPORT,
    LOADING
} from "../../types";
import MessageUtils from "../../../utils/MessageUtils";

export const loadReport = (id, timeIntervalObject) => {
    return (dispatch) => {

        dispatch({type: LOADING, payload: true});

        const url = `/restaurant/${id}/order-report`;

        axios().post(url, timeIntervalObject)
            .then(response => loadReportSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:reportsActions.loadReportFail')))
    }
};

const loadReportSuccess = (dispatch, response) => {
    dispatch({type: LOADING, payload: false});
    dispatch({ type: LOAD_REPORT, payload: response.data })
};

export const downloadProductReport = (id, timeIntervalObject) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${id}/product-report`;
        let timeIntervalObjectCopy = { ...timeIntervalObject };

        axios().post(url, timeIntervalObjectCopy)
            .then(res => {
                dispatch({ type: LOADING, payload: false });
                // console.log('report ', res)
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:notificationsActions.downloadStartedMsg'));
                // let blob = new Blob([res.data], { type: 'application/csv' });
                // let link = document.createElement('a');
                // link.href = window.URL.createObjectURL(blob);
                // link.download = `product_production_report_${timeIntervalObjectCopy.startDate}_${timeIntervalObjectCopy.endDate}.csv`;
                // link.click();
            })
            .catch(err => {
                console.log('ERR ', err);
                // dispatch({ type: DOWNLOAD_PRODUCT_REPORT_ERROR, payload: err.data.data.userMessage });
                MessageUtils.errorMessageResponse(dispatch, err.response.data, err.response.userMessage);
            })
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
}

export const downloadTipAndTaxesReport = (id, timeIntervalObject) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const url = `/restaurant/${id}/tips-and-taxes-report`;

        axios().post(url, timeIntervalObject)
            .then(res => {
                dispatch({ type: LOADING, payload: false });
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `tips_taxes_report_${timeIntervalObject.startDate}_${timeIntervalObject.endDate}.csv`;
                link.click();
            })
            .catch(err => console.log('ERR ', err))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/reports/ReportsActions.js